import { api } from '..';

export function getExhibitionScenes(payload) {
  return api('GET', `/panel/exhibition-scenes`, payload);
}
export function getCreateExhibitionScenes(payload) {
  return api('GET', `/panel/v2/exhibition-scenes`, payload);
}
export function getTeam(payload) {
  return api('GET', `/panel/teams`, payload);
}

export function editTeam(payload) {
  return api('PATCH', `/panel/teams`, payload);
}

export function getOrders(payload) {
  return api('GET', `/panel/orders`, payload);
}

export function setOrders(payload) {
  return api('POST', `/panel/orders`, payload);
}

export function estimateOrder(payload) {
  return api('POST', `/panel/orders/estimate`, payload, {lang:payload.lang});
}
